import angular from 'angular';

angular.module('myConsultApp').factory('MediaService', ($resource, ENV, Session) => {
  const mediaService = {};
  const headers = { Authorization: 'Bearer ' + Session.accessToken };

  mediaService.getMedia = (
    search,
    status,
    dm_status,
    types,
    categories,
    organization,
    order,
    page_size = 10,
  ) => {
    const media = $resource(`${ENV.apiEndpoint}/1.0/media/files/`, {}, { get: { headers } });
    const searchData = {
      search,
      status,
      dm_status,
      organization,
      categories,
      types,
      order,
      page_size,
    };

    return media.get(searchData).$promise;
  };

  mediaService.getMediaByPet = (id, order, categories, page_size) => {
    const media = $resource(`${ENV.apiEndpoint}/1.0/pets/:id/media/`, { id }, { get: { headers } });

    const searchData = {
      order,
      categories,
      page_size,
    };

    return media.get(searchData).$promise;
  };

  mediaService.getMediaByUser = (id) => {
    const media = $resource(
      `${ENV.apiEndpoint}/1.0/identities/:id/media/`,
      { id },
      { get: { headers } },
    );

    return media.get().$promise;
  };

  mediaService.getMediaTypes = () => {
    const mediaTypes = $resource(`${ENV.apiEndpoint}/1.0/media/types/`, {}, { get: { headers } });

    return mediaTypes.get().$promise;
  };

  mediaService.getMediaPage = (url) => {
    const medias = $resource(url, {}, { get: { headers } });

    return medias.get({}).$promise;
  };

  mediaService.getMediaInfo = (id) => {
    const media = $resource(
      `${ENV.apiEndpoint}/1.0/media/files/:id/`,
      { id },
      { get: { headers } },
    );

    return media.get().$promise;
  };

  mediaService.updateMediaFromDM = (id) => {
    const media = $resource(
      `${ENV.apiEndpoint}/1.0/media/files/:id/?update_data_from_source=true`,
      { id },
      { get: { headers } },
    );

    return media.get().$promise;
  };

  mediaService.setMediaInfo = (id, settings) => {
    const media = $resource(
      `${ENV.apiEndpoint}/1.0/media/files/:id/`,
      { id: id },
      { save: { method: 'PUT', headers } },
    );

    return media.save(settings).$promise;
  };

  mediaService.getMediaURL = (id) => {
    const media = $resource(
      `${ENV.apiEndpoint}/1.0/media/files/:id/token/`,
      { id },
      { get: { method: 'GET', headers } },
    );

    return media.get().$promise;
  };

  //   mediaService.uploadVideo = (id, file) => {
  //     const media = $resource(
  //       `${ENV.apiEndpoint}/1.0/media/files/:id/`,
  //       { id },
  //       { save: { method: 'PUT', headers } },
  //     );
  //     const settings = {
  //       files: {
  //         file_url:
  //           'https://www.learningcontainer.com/wp-content/uploads/2020/05/sample-mp4-file.mp4',
  //       },
  //     };

  //     return media.save(settings).$promise;
  //   };

  mediaService.createMediaObject = (settings) => {
    const media = $resource(
      `${ENV.apiEndpoint}/1.0/media/files/`,
      {},
      { save: { method: 'POST', headers } },
    );

    return media.save(settings).$promise;
  };

  return mediaService;
});
